import { NgModule, Directive, ElementRef, AfterViewInit, OnDestroy, HostBinding, HostListener, Input } from '@angular/core';
import { DomHandler } from '../dom/domhandler';
import { CommonModule } from '@angular/common';
export class Button implements AfterViewInit, OnDestroy {

     iconPos: string = 'left';

     cornerStyleClass: string = 'ui-corner-all';
public _label: string;
public _icon: string;
public initialized: boolean;
/**
 * @param {?} el
 * @param {?} domHandler
 */
constructor(public el: ElementRef,
public domHandler: DomHandler) { }
/**
 * @return {?}
 */
ngAfterViewInit() {
        this.domHandler.addMultipleClasses(this.el.nativeElement, this.getStyleClass());
        if (this.icon) {
            let /** @type {?} */ iconElement = document.createElement("span");
            let /** @type {?} */ iconPosClass = (this.iconPos == 'right') ? 'ui-button-icon-right' : 'ui-button-icon-left';
            iconElement.className = iconPosClass + ' ui-clickable fa fa-fw ' + this.icon;
            this.el.nativeElement.appendChild(iconElement);
        }

        let /** @type {?} */ labelElement = document.createElement("span");
        labelElement.className = 'ui-button-text ui-clickable';
        labelElement.appendChild(document.createTextNode(this.label || 'ui-btn'));
        this.el.nativeElement.appendChild(labelElement);
        this.initialized = true;
    }
/**
 * @return {?}
 */
getStyleClass(): string {
        let /** @type {?} */ styleClass = 'ui-button ui-widget ui-state-default ' + this.cornerStyleClass;
        if (this.icon) {
            if (this.label != null && this.label != undefined) {
                if (this.iconPos == 'left')
                    styleClass = styleClass + ' ui-button-text-icon-left';
                else
                    styleClass = styleClass + ' ui-button-text-icon-right';
            }
            else {
                styleClass = styleClass + ' ui-button-icon-only';
            }
        }
        else {
            styleClass = styleClass + ' ui-button-text-only';
        }

        return styleClass;
    }
/**
 * @return {?}
 */
get label(): string {
        return this._label;
    }
/**
 * @param {?} val
 * @return {?}
 */
set label(val: string) {
        this._label = val;

        if (this.initialized) {
            this.domHandler.findSingle(this.el.nativeElement, '.ui-button-text').textContent = this._label;
        }
    }
/**
 * @return {?}
 */
get icon(): string {
        return this._icon;
    }
/**
 * @param {?} val
 * @return {?}
 */
set icon(val: string) {
        this._icon = val;

        if (this.initialized) {
            let /** @type {?} */ iconPosClass = (this.iconPos == 'right') ? 'ui-button-icon-right' : 'ui-button-icon-left';
            this.domHandler.findSingle(this.el.nativeElement, '.fa').className =
                iconPosClass + ' ui-clickable fa fa-fw ' + this.icon;
        }
    }
/**
 * @return {?}
 */
ngOnDestroy() {
        while (this.el.nativeElement.hasChildNodes()) {
            this.el.nativeElement.removeChild(this.el.nativeElement.lastChild);
        }

        this.initialized = false;
    }
static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
    selector: '[pButton]',
    providers: [DomHandler]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ElementRef, },
{type: DomHandler, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'iconPos': [{ type: Input },],
'cornerStyleClass': [{ type: Input },],
'label': [{ type: Input },],
'icon': [{ type: Input },],
};
}

function Button_tsickle_Closure_declarations() {
/** @type {?} */
Button.decorators;
/**
 * @nocollapse
 * @type {?}
 */
Button.ctorParameters;
/** @type {?} */
Button.propDecorators;
/** @type {?} */
Button.prototype.iconPos;
/** @type {?} */
Button.prototype.cornerStyleClass;
/** @type {?} */
Button.prototype._label;
/** @type {?} */
Button.prototype._icon;
/** @type {?} */
Button.prototype.initialized;
/** @type {?} */
Button.prototype.el;
/** @type {?} */
Button.prototype.domHandler;
}

export class ButtonModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
    imports: [CommonModule],
    exports: [Button],
    declarations: [Button]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function ButtonModule_tsickle_Closure_declarations() {
/** @type {?} */
ButtonModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
ButtonModule.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
